// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  shops: [],
  sistem: [],
  brand: [],
  type: [],
  itemSystem: [],
  itemBrand: [],
  itemType: [],
  garageWorkShops: [],
  message: '',
  env: '',
  garageService: [],
};

const actions = {
  setShops:
    (token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch('/api/bread/jwt/garage_workshops/static/search', options);
          const workShops = await response.json();

          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ shops: workShops.shops });
            setState({ sistem: workShops.sistem });
            setState({ brand: workShops.brand });
            setState({ type: workShops.type });
            setState({ garageWorkShops: workShops.garageWorkShops });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  setVehicleSystem:
    (token, locale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch(
            `/api/bread/jwt/vehicle_systems/static/search?lang=${locale}`,
            options
          );
          const vehicleSystem = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ itemSystem: vehicleSystem[locale] });
            resolve(getState().itemSystem);
          }
        } catch (e) {
          reject(e);
        }
      }),
  setVehicleType:
    (token, locale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch(
            `/api/bread/jwt/vehicle_types/static/search?lang=${locale}`,
            options
          );
          const vehicleTypes = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ itemType: vehicleTypes[locale] });
            resolve(getState().itemType);
          }
        } catch (e) {
          reject(e);
        }
      }),
  setBrand:
    (token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch('/api/bread/jwt/brands/static/search', options);
          const brand = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ itemBrand: brand });
            resolve(getState().itemBrand);
          }
        } catch (e) {
          reject(e);
        }
      }),
  updateWorkShop: (dataWorkShop, token) => () =>
    new Promise(async (resolve, reject) => {
      try {
        const options = {
          method: 'POST',
          body: JSON.stringify(dataWorkShop),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `bearer ${token}`,
          },
        };

        const response = await fetch(
          '/api/bread/jwt/garage_workshops/static/updateWorkShop',
          options
        );
        const garageWorkShopResponse = await response.json();

        if (response.status !== 200) {
          response.error = garageWorkShopResponse;
          reject(response);
        } else {
          resolve(true);
        }
      } catch (e) {
        reject(e);
      }
    }),
  getTokenService:
    (dataService, token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(dataService),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch(
            '/api/bread/jwt/garage_workshops/static/token_service',
            options
          );
          const garage = await response.json();

          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ garageService: garage.service });
            resolve(getState().garageService);
          }
        } catch (e) {
          reject(e);
        }
      }),
  setService: (dataService, token, locale) => () =>
    new Promise(async (resolve, reject) => {
      try {
        const options = {
          method: 'POST',
          body: JSON.stringify(dataService),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `bearer ${token}`,
          },
        };

        const response = await fetch(
          `/api/bread/jwt/services/static/garage_service?lang=${locale}`,
          options
        );
        const serviceStatus = await response.json();

        if (response.status !== 200) {
          response.error = serviceStatus;
          reject(response);
        } else {
          resolve(true);
        }
      } catch (e) {
        reject(e);
      }
    }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'garage_workshop',
});

export default createHook(Store);
